import {
  FlagIcon,
  HomeIcon,
  ChatBubbleLeftRightIcon,
  UserGroupIcon,
  ExclamationTriangleIcon,
  PencilIcon,
  PencilSquareIcon,
  CheckBadgeIcon,
  CurrencyEuroIcon,
  UserIcon,
  DocumentTextIcon,
  ComputerDesktopIcon,
  TagIcon,
  QuestionMarkCircleIcon,
  GiftIcon,
  DocumentArrowDownIcon,
  CalendarDaysIcon,
  ClockIcon,
} from '@heroicons/vue/24/outline'
import type { NavGroup } from '@/types/navigation.types'

/**
 * Full sidebar navigation config.
 * Labels are i18n keys resolved at render time via $t().
 * Groups are separated by dividers in the sidebar.
 * Visibility is controlled by the `roles` array on each item/group.
 */
export const navigationGroups: NavGroup[] = [
  {
    id: 'personal',
    roles: ['admin', 'people_culture', 'leader', 'employee'],
    items: [
      {
        routeName: 'dashboard',
        label: 'nav.home',
        icon: HomeIcon,
        roles: ['admin', 'people_culture', 'leader', 'employee'],
      },
      {
        routeName: 'my-reviews',
        label: 'nav.my_reviews',
        icon: ChatBubbleLeftRightIcon,
        roles: ['admin', 'people_culture', 'leader', 'employee'],
      },
      {
        routeName: 'team',
        label: 'nav.team',
        icon: UserGroupIcon,
        roles: ['admin', 'people_culture', 'leader', 'employee'],
      },
      {
        routeName: 'faq',
        label: 'nav.faq',
        icon: QuestionMarkCircleIcon,
        roles: ['admin', 'people_culture', 'leader', 'employee'],
      },
      {
        routeName: 'discounts',
        label: 'nav.discounts',
        icon: GiftIcon,
        roles: ['admin', 'people_culture', 'leader', 'employee'],
      },
      {
        routeName: 'leave',
        label: 'nav.leave',
        icon: CalendarDaysIcon,
        roles: ['admin', 'people_culture', 'leader', 'employee'],
        feature: 'leave.requests',
      },
    ],
  },
  {
    id: 'management',
    roles: ['admin', 'people_culture', 'leader'],
    items: [
      {
        routeName: 'deadlines',
        label: 'nav.deadlines',
        icon: ExclamationTriangleIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'reviews',
        label: 'nav.reviews_mgmt',
        icon: PencilSquareIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'role-fit',
        label: 'nav.role_fit',
        icon: CheckBadgeIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'compensations',
        label: 'nav.compensations',
        icon: CurrencyEuroIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'reports',
        label: 'nav.reports',
        icon: DocumentArrowDownIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
    ],
  },
  {
    id: 'admin',
    roles: ['admin', 'people_culture', 'leader'],
    items: [
      {
        routeName: 'people',
        label: 'nav.people',
        icon: UserIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'leave-admin',
        label: 'nav.leave_admin',
        icon: ClockIcon,
        roles: ['admin', 'people_culture'],
        feature: 'leave.requests',
      },
      {
        routeName: 'features',
        label: 'nav.features',
        icon: FlagIcon,
        roles: ['admin'],
      },
      {
        routeName: 'contracts',
        label: 'nav.contracts',
        icon: DocumentTextIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'devices',
        label: 'nav.devices',
        icon: ComputerDesktopIcon,
        roles: ['admin', 'people_culture', 'leader'],
      },
      {
        routeName: 'compliance',
        label: 'nav.compliance',
        icon: PencilIcon,
        roles: ['admin', 'people_culture'],
      },
      {
        routeName: 'roles',
        label: 'nav.roles',
        icon: TagIcon,
        roles: ['admin', 'people_culture'],
      },
    ],
  },
]
